import { colors, s8 } from '@ardoq/design-tokens';
import { VISUALIZATION_LEGEND_CONTAINER_CLASS_NAME } from '@ardoq/global-consts';
import styled from 'styled-components';

export const ViewContainer = styled.div`
  height: 100%;
  overflow: hidden;
  position: relative; /* needed for placing legend properly when exporting to png */
  cursor: grab;

  & .${VISUALIZATION_LEGEND_CONTAINER_CLASS_NAME} {
    cursor: initial;
  }
`;

export const NotificationWrapper = styled.div`
  background-color: ${colors.white950};
  padding: ${s8};
  z-index: 1;
  position: relative;
`;

/** container for absolute-positioned ComponentDecorator elements */
export const DependencyWheelContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const Svg = styled.svg`
  width: 100%;
  height: 100%;
  user-select: none;
`;

type MinWidthWrapperProps = {
  $minWidth: number;
};

export const MinWidthWrapper = styled.div<MinWidthWrapperProps>`
  min-width: ${props => props.$minWidth}px;
`;
